import { create } from 'zustand';
import type { EventState } from './types';

export const useEventStore = create<EventState>(() => ({
  activeEvent: null,
  meta: null,
}));
